/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventResult } from './eventResult';
import { BankAccountResult } from './bankAccountResult';
import { MembershipResult } from './membershipResult';


/**
 * User list.
 */
export interface UserResult { 
    /**
     * Id Hash. UUI (Unique User Identifier)
     */
    idHash?: string;
    /**
     * Login Name
     */
    loginName?: string;
    /**
     * Password
     */
    password?: string;
    /**
     * Name
     */
    name?: string;
    /**
     * First Surname
     */
    firstSurname?: string;
    /**
     * Second Surname
     */
    secondSurname?: string;
    /**
     * NIF
     */
    nif?: string;
    /**
     * KYC Maindata Verified
     */
    kycMaindataVerified?: boolean;
    /**
     * Email
     */
    email?: string;
    /**
     * Email Verified
     */
    emailVerified?: boolean;
    /**
     * Address
     */
    address?: string;
    /**
     * Postal Code
     */
    postalCode?: string;
    /**
     * Country
     */
    country?: string;
    /**
     * Province
     */
    province?: string;
    /**
     * City
     */
    city?: string;
    /**
     * Country Code
     */
    countryCode?: string;
    /**
     * Country Name
     */
    countryName?: string;
    /**
     * Region Code
     */
    regionCode?: string;
    /**
     * Region Name
     */
    regionName?: string;
    /**
     * City Code
     */
    cityCode?: string;
    /**
     * City Name
     */
    cityName?: string;
    /**
     * KYC Address Verified
     */
    kycAddressVerified?: boolean;
    /**
     * Birth place Country Code
     */
    birthPlaceCountryCode?: string;
    birthPlacecountryName?: string;
    /**
     * Birth place Region Code
     */
    birthPlaceRegionCode?: string;
    birthPlaceregionName?: string;
    /**
     * Birth place City Code
     */
    birthPlaceCityCode?: string;
    /**
     * Birth place City Name
     */
    birthPlaceCityName?: string;
    /**
     * KYC Birth place Verified
     */
    kycBirthPlaceVerified?: boolean;
    /**
     * Telephone
     */
    telephone?: string;
    /**
     * Telephone Verified
     */
    telephoneVerified?: boolean;
    /**
     * Telephone2
     */
    telephone2?: string;
    /**
     * Birth Date. Format yyyy-MM-dd HH:mm:ss
     */
    birthDate?: string;
    /**
     * User\'s handwritten signature.
     */
    handwrittenSignature?: string;
    /**
     * Verified data validity expiration date, after which the verification process should be performed again. Format yyyy-MM-dd HH:mm:ss
     */
    dataValidUntil?: string;
    /**
     * Language
     */
    language?: string;
    /**
     * Role
     */
    role?: string;
    /**
     * Account Type
     */
    accountType?: string;
    /**
     * Id External
     */
    idExternal?: string;
    /**
     * Firebase cloud Message token
     */
    firebaseToken?: string;
    /**
     * Photo. Encoded in Base64 format
     */
    photo?: UserResult.PhotoEnum;
    /**
     * Creation Date. Format yyyy-MM-dd HH:mm:ss
     */
    creationDate?: string;
    /**
     * The user agrees to receive commercial communications.
     */
    agreeCommercialCommunications?: boolean;
    /**
     * BankAccounts. List of bank accounts.
     */
    bankAccounts?: Array<BankAccountResult>;
    /**
     * Memberships. List of Memberships.
     */
    memberships?: Array<MembershipResult>;
    /**
     * Nationalities. List of the countries the user has nationality.
     */
    nationalities?: Array<string>;
    /**
     * List of Events.
     */
    events?: Array<EventResult>;
    /**
     * Subject DID
     */
    subjectDid?: string;
    /**
     * Company
     */
    company?: string;
    /**
     * Sex
     */
    sex?: string;
    /**
     * Bank
     */
    bank?: string;
    /**
     * Bank Branch
     */
    bankBranch?: string;
    /**
     * Bank Account Control Digit
     */
    bankAccountControlDigit?: string;
    /**
     * Bank Account
     */
    bankAccount?: string;
    /**
     * Bank IBAN Code
     */
    bankIBANCode?: string;
    /**
     * Bank Reference
     */
    bankReference?: string;
    /**
     * Partner Create Date
     */
    partnerCreateDate?: string;
    /**
     * Partner Last Update Date
     */
    partnerLastUpdateDate?: string;
    /**
     * Subscription Number
     */
    subscriptionNumber?: string;
    /**
     * Subscription Old Number
     */
    subscriptionOldNumber?: string;
    /**
     * Subscription Type
     */
    subscriptionType?: string;
    /**
     * Subscription Frequency
     */
    subscriptionFrequency?: string;
    /**
     * Subscription Paid State
     */
    subscriptionPaidState?: string;
    /**
     * Subscription Marked Price
     */
    subscriptionMarkedPrice?: string;
    /**
     * Subscription Discount
     */
    subscriptionDiscount?: string;
    /**
     * Subscription Selling Price (marked price minus discount)
     */
    subscriptionSellingPrice?: string;
    /**
     * Subscription Access Type
     */
    subscriptionAccessType?: string;
    /**
     * Subscription Access Type Description
     */
    subscriptionAccessTypeDescription?: string;
    /**
     * Subscription Area Name
     */
    subscriptionAreaName?: string;
    /**
     * Subscription Area Doors
     */
    subscriptionAreaDoors?: string;
    /**
     * Subscription Sector Name
     */
    subscriptionSectorName?: string;
    /**
     * Subscription Location
     */
    subscriptionLocation?: string;
    /**
     * Subscription Row
     */
    subscriptionRow?: string;
    /**
     * Subscription Seat
     */
    subscriptionSeat?: string;
    /**
     * Subscription Acquisition Date
     */
    subscriptionAcquisitionDate?: string;
    /**
     * Subscription Permission
     */
    subscriptionPermission?: string;
    /**
     * Remarks
     */
    remarks?: string;
    /**
     * Reference
     */
    reference?: string;
    /**
     * Province Code
     */
    provinceCode?: string;
    /**
     * Spouse. Values 0 (has not spouse) or 1 (has spouse)
     */
    spouse?: string;
    /**
     * Children number. Values 0 (has not children) or 1 (has one son) or 2...
     */
    childrenNumber?: string;
    /**
     * Pay Hash Credit Card
     */
    payHashCreditCard?: string;
    /**
     * Pay Hash Paypal
     */
    payHashPaypal?: string;
    /**
     * Pay Hash Bizum
     */
    payHashBizum?: string;
    /**
     * Credit Card Not After. Maximum length 255
     */
    payCreditCardNotAfter?: string;
    /**
     * Credit Card Last Digits. Maximum length 255
     */
    payCreditCardLastDigits?: string;
    /**
     * Credit Card Type. Maximum length 255
     */
    payCreditCardType?: string;
    /**
     * User signup referral. Maximum length 255
     */
    userOrigin?: string;
    /**
     * Subscription start date
     */
    subscriptionNotBefore?: string;
    /**
     * Subscription end date
     */
    subscriptionNotAfter?: string;
    /**
     * Pin
     */
    pin?: string;
    /**
     * QR. Encoded in Base64 format
     */
    qr?: UserResult.QrEnum;
    creditCardType?: string;
    extraAttributes?: { [key: string]: string; };
    /**
     * Birth place Region Name
     */
    birthPlaceRegionName?: string;
    /**
     * Birth place Country Name
     */
    birthPlaceCountryName?: string;
    extraAttributesBlob?: { [key: string]: string; };
}
export namespace UserResult {
    export type PhotoEnum = '[B@1abfe081';
    export const PhotoEnum = {
        B1abfe081: '[B@1abfe081' as PhotoEnum
    };
    export type QrEnum = '[B@2a685eba';
    export const QrEnum = {
        B2a685eba: '[B@2a685eba' as QrEnum
    };
}


